module.exports = __webpack_public_path__ + "static/img/8.b72061d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/8.png
// module id = im0I
// module chunks = 0